import { styled } from '@mui/material/styles';

export const HeaderTitle = styled('h1')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));